import type { MessageFormatElement } from "react-intl";

import messagesDE from "@/assets/locales/de.json";
import messagesEN from "@/assets/locales/en.json";
import messagesES from "@/assets/locales/es.json";
import messagesFR from "@/assets/locales/fr.json";
import messagesFRCA from "@/assets/locales/fr-CA.json";

type Messages = Record<string, MessageFormatElement[]>;

// Order matters for the language fallback: a French locale without an exact
// match (fr-FR, fr-BE) resolves to the first "fr" entry, so `fr` precedes `fr-CA`.
const LOCALES = {
  en: messagesEN as Messages,
  de: messagesDE as Messages,
  es: messagesES as Messages,
  fr: messagesFR as Messages,
  "fr-CA": messagesFRCA as Messages,
};

export type LocaleName = keyof typeof LOCALES;

export const SUPPORTED_LOCALES = Object.keys(LOCALES) as readonly LocaleName[];

export function getLocaleMessages(locale: LocaleName): Messages {
  return LOCALES[locale];
}
